export class Utils{
    deepCopy (obj: object): any{
        return obj && JSON.parse(JSON.stringify(obj));
    }  
}



